export const WIRE_TRANSFERS_LIMIT = 100
